import React, { Suspense, useEffect, useRef ,useState} from 'react';
import { Canvas,useFrame  } from '@react-three/fiber';

import { OrbitControls } from '@react-three/drei';
import Model from './Model'; /* highlight-line */

const Sphere= (props) => {

   const mesh = useRef();

   useFrame(() => {
       if (mesh.current) mesh.current.rotation.y += 0.01;
   });

   return (<mesh  ref={mesh} visible>
       <ambientLight intensity={1.25} />
         <ambientLight intensity={0.1} />
         <directionalLight intensity={0.4} />
         <Suspense fallback={null}>
            <Model position={[0.025, -0.9, 0]} /> 
         </Suspense>
         <OrbitControls />
   </mesh>);

}
export default function App() {
   const [flag, setFlag] = useState(true)
   useEffect(() => {
     setTimeout(()=>{
       setFlag(false)
     },6000);
   
    
   }, [flag])
   
   const ref = useRef();
   return (
      <>
      {flag && <span className="loader"></span>}
      <Canvas
      ref={ref}
         camera={{ position: [2, 0, 12.25], fov: 10 }}
         style={{
            backgroundColor: '#002233',
            width: '100vw',
            height: '100vh',
         }}
      >
         <Sphere/>
        
      </Canvas></>
   );
}